var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.26 7.32a6.03 6.03 0 010 8.475l-6.85 6.85a6.03 6.03 0 01-7.428.833 6.528 6.528 0 01-1.06-.833 5.324 5.324 0 01-.819-1.059 5.989 5.989 0 01.82-7.415l.197-.198a3.488 3.488 0 011.144.749 3.305 3.305 0 01.734 1.144l-.183.183a3.347 3.347 0 00-.749 3.574 3.488 3.488 0 00.749 1.144 3.107 3.107 0 001.144.734 3.32 3.32 0 003.559-.734l6.864-6.865A3.333 3.333 0 0021.665 9.2l-1.68 1.695a5.325 5.325 0 00-.82-1.06 6.539 6.539 0 00-1.06-.832l1.681-1.681a6.017 6.017 0 018.475 0zM10.69 23.013a5.327 5.327 0 00.82 1.06 6.548 6.548 0 001.06.833l-.58.58a6.003 6.003 0 01-8.474-8.475l5.748-5.763a5.989 5.989 0 017.415-.819 5.325 5.325 0 011.06.82 6.538 6.538 0 01.833 1.059 5.72 5.72 0 01-.636 7.231l-.381.382a3.488 3.488 0 01-1.144-.749 3.008 3.008 0 01-.734-1.144l.367-.367a2.952 2.952 0 00.55-3.376 3.007 3.007 0 00-.706-1.144 3.487 3.487 0 00-1.144-.748 3.319 3.319 0 00-3.573.748l-5.777 5.748a3.333 3.333 0 104.504 4.916l.03-.028q.095-.089.183-.184z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--link-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'LinkIcon';
export default Icon;